var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',[_c('main-nav',{staticClass:"sticky-nav"}),_c('div',{staticClass:"spacer"}),_c('mobile-bottom-nav'),_c('secondary-nav'),_c('account-modal',{attrs:{"userinfo":_vm.$userInfo,"keycloak-user-profile":_vm.keycloakUserProfile}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }